import { __decorate, __extends } from "tslib";
import { Component, Vue, Prop } from 'vue-property-decorator';

var StatementConfirm = function (_super) {
  __extends(StatementConfirm, _super);

  function StatementConfirm() {
    return _super !== null && _super.apply(this, arguments) || this;
  }

  StatementConfirm.prototype.handerConfirmationHetterChange = function (e) {
    if (e) {
      var value = e.target.checked;
      this.$emit('input', value || undefined);
      this.$emit('validate');
    }
  };

  __decorate([Prop({
    "default": ''
  })], StatementConfirm.prototype, "value", void 0);

  __decorate([Prop({
    type: String,
    "default": ''
  })], StatementConfirm.prototype, "content", void 0);

  StatementConfirm = __decorate([Component], StatementConfirm);
  return StatementConfirm;
}(Vue);

export default StatementConfirm;